import { FormlyFieldConfig } from '@ngx-formly/core';
import { cloneDeep, merge } from 'lodash-es';
import type { Module, OptionsItem } from '../../features/admin/modules/modules.model';

export interface LinkedData extends OptionsItem {
  module: Module;
}

export const OPERATOR_SELECT_FIELD: FormlyFieldConfig = cloneDeep({
  key: 'operator',
  type: 'select',
  props: {
    label: 'Vergelijking',
    options: [
      { value: '==', label: 'Is gelijk aan' },
      { value: '!=', label: 'Is niet gelijk aan' },
      { value: 'contains', label: 'Bevat tekst' },
      { value: '!contains', label: 'Bevat tekst niet' },
      { value: 'isnull', label: 'Is leeg' },
      { value: '!isnull', label: 'Is niet leeg (werkt alleen bij conditioneel weergeve/disable)' },
      { value: '>', label: 'Is groter dan' },
      { value: '>=', label: 'Is groter of gelijk aan' },
      { value: '<', label: 'Is kleiner dan' },
      { value: '<=', label: 'Is kleiner of gelijk aan' },
      { value: 'between', label: 'Tussen' },
      { value: 'length', label: 'Lengte van array is gelijk aan' },
      { value: 'istrue', label: 'Is waar (boolean)' },
      { value: 'isfalse', label: 'Is onwaar (boolean)' },
    ],
  },
});

export const BASED_ON_SELECTED_FIELD: FormlyFieldConfig = cloneDeep({
  key: 'basedOn',
  type: 'select',
  defaultValue: 'static',
  props: {
    label: 'Beoordeel op',
    options: [
      { value: 'static', label: 'Vaste waarde' },
      { value: 'dynamic', label: 'Waarde van invoerveld' },
      { value: 'currentDate', label: 'Waarde van huidige tijd en datum' },
    ],
  },
});

// Optional: a helper function to adjust the field if needed
export function createFieldWithOverrides(
  field: FormlyFieldConfig,
  overrides?: Partial<FormlyFieldConfig>
): FormlyFieldConfig {
  return merge({
    ...field,
    ...overrides,
  });
}

export function createLinkedData(field: FormlyFieldConfig): LinkedData[] {
  const linkedData: LinkedData[] = [];
  this.field.props?.optionsArray?.forEach((optionsItem: OptionsItem) => {
    if (optionsItem.moduleLinkedField != undefined) {
      linkedData.push({
        ...optionsItem,
        filters: optionsItem.filters ?? [],
        module: this.modulesStore.getModuleByCode(optionsItem.moduleCode),
      });
    }
  });
  return linkedData;
}
